import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, Input, AfterViewInit, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { HttpClient } from '@angular/common/http';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
import { CommonService } from '../../../../services/common/common.service';
import { PlotSeedReleaseBreakdownViewSliderModelService } from './plot-seed-release-breakdown-view-slider-model.service';
import { PlotSeedReleaseService } from '../../../../services/seed/plot-seed-release.service';

@Component({
  selector: 'app-plot-seed-release-breakdown-view',
  templateUrl: './plot-seed-release-breakdown-view.component.html',
  styleUrl: './plot-seed-release-breakdown-view.component.scss'
})

export class PlotSeedReleaseBreakdownViewComponent implements OnInit, AfterViewInit {
  accountNumber: number;
  column: any;
  contactTypeList: any = [];
  cropYear: any;
  currentErrorRow = 1;
  dashboardFilter: DashboardFilter;
  dataChangeSubscription: any;
  seedFulfillmentBreakdownLotsDS: MatTableDataSource<SeedFulfillmentBreakdownLots>;
  seedFulfillmentBreakdownFootersColumns: string[] = [];
  seedFulfillmentBreakdownColumns: string[] = ['itemDescription', 'lot', 'location', 'memoLot1', 'memoLot2', 'quantityAvailable', 'weight', 'lotLocationReleaseQuantity'];
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  errorMsgs = new Array();
  errorsList: Array<string> = [];
  error = false;
  hasChangeAdded = false;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  index = 0;
  isEditMode = false;
  isSelectDIDisabled = true;
  nextErrorId = 0;
  showErrorBlock = false;
  submitButtonClicked = false;
  isViewOrEdit: string;
  releaseOrderItem: any;
  branchPlantCode: any;
  isReleased = true;
  quantityAvailability: number;
  branchPlantData: any;
  existingLots: Array<string> = [];
  newLots: Array<string> = [];
  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private plotSeedReleaseBreakdownViewSliderModelService: PlotSeedReleaseBreakdownViewSliderModelService,
    private plotSeedReleaseService: PlotSeedReleaseService,
    private toastrService: ToastrService,
    private commonService: CommonService
  ) {
    this.dashboardFilter = new DashboardFilter();
    this.dataChangeSubscription = this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    });
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
  }

  ngOnInit() {
    this.isViewOrEdit = this.plotSeedReleaseBreakdownViewSliderModelService.viewEditText;
    this.releaseOrderItem = this.plotSeedReleaseBreakdownViewSliderModelService.releaseOrderItem;
    this.branchPlantCode = this.plotSeedReleaseBreakdownViewSliderModelService.branchPlant;

    if (this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST)) {
      const branchPlantList = JSON.parse(this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST));
      this.branchPlantData = branchPlantList.filter(x => x.data == this.headerCompany && x.id == this.branchPlantCode)[0];
    }

    if (this.localStorageService.get('plotSeedReleaseBreakdown')) {
      const seedFulfillmentLotsBreakdown = JSON.parse(this.localStorageService.get('plotSeedReleaseBreakdown'));
      const seedFulfillmentLotsList = seedFulfillmentLotsBreakdown.filter(x => x.itemNumber === this.releaseOrderItem.itemNumber);
      if (seedFulfillmentLotsList && seedFulfillmentLotsList.length > 0) {
        let quantity = 0;
        seedFulfillmentLotsList.map(x => {
          quantity += x.quantityAvailable;
          if (x.lotLocationReleaseQuantity > 0) {
            const lotKey = x.lot + '$' + x.weight;
            this.existingLots.push(lotKey);
          }
        });
        this.quantityAvailability = quantity;
        this.seedFulfillmentBreakdownLotsDS = new MatTableDataSource(seedFulfillmentLotsList);
      }
      else {
        this.getFulfillmentBreakdownLots();
      }
    } else {
     this.getFulfillmentBreakdownLots();
    }

  }

  getFulfillmentBreakdownLots() {
    this.loaderService.setLoaderStatus(true);
    const itemsList = new Array<ItemsList>();
    const itemList = new ItemsList();
    itemList.ReleaseItemId = 0;
    itemList.ItemNumber = this.releaseOrderItem.itemNumber;
    itemList.ItemId = this.releaseOrderItem.itemId;
    itemList.ItemUOM = this.releaseOrderItem.primaryUOM;
    itemList.BranchPlant = this.branchPlantCode;
    itemList.ReleaseQuantity = this.releaseOrderItem.releaseQty;
    itemsList.push(itemList);

    this.plotSeedReleaseService.getItemAvailabilityByLot(itemsList).subscribe(result => {
      if (result && result.length > 0) {
        const seedFulfillmentLots = new Array<SeedFulfillmentBreakdownLots>();
        let quantity = 0;
        result.forEach(x => {
          const seedFulfillmentBreakdownLot = new SeedFulfillmentBreakdownLots();
          seedFulfillmentBreakdownLot.brand = this.releaseOrderItem.brand;
          seedFulfillmentBreakdownLot.marketingBrand = this.releaseOrderItem.marketingBrand;
          seedFulfillmentBreakdownLot.itemDescription = x.itemDescription;
          seedFulfillmentBreakdownLot.itemNumber = x.itemNumber;
          seedFulfillmentBreakdownLot.lot = x.lot;
          seedFulfillmentBreakdownLot.memoLot1 = x.memoLot1;
          seedFulfillmentBreakdownLot.memoLot2 = x.memoLot2;
          seedFulfillmentBreakdownLot.location = x.location;
          seedFulfillmentBreakdownLot.onHand = x.onHand;
          seedFulfillmentBreakdownLot.lotLocationReleaseQuantity = x.lotLocationReleaseQuantity;
          seedFulfillmentBreakdownLot.weight = Math.round(x.weight * 100) / 100;
          seedFulfillmentBreakdownLot.itemWeight = x.itemWeight;
          seedFulfillmentBreakdownLot.quantityAvailable = x.quantityAvailable;
          quantity += x.quantityAvailable;

          seedFulfillmentLots.push(seedFulfillmentBreakdownLot);

          if (x.lotLocationReleaseQuantity > 0) {
            const lotKey = x.lot + '$' + x.weight;
            this.existingLots.push(lotKey);
          }
        });
        this.quantityAvailability = quantity;
        this.seedFulfillmentBreakdownLotsDS = new MatTableDataSource(seedFulfillmentLots);
      }
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  returnToRelease() {
    this.plotSeedReleaseBreakdownViewSliderModelService.plotSeedReleaseBreakdownViewClose();
  }



  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
  //  this.setSeedEditPageHeight();
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

}
export class SeedFulfillmentBreakdownLots {
  itemNumber: number;
  brand: string;
  itemDescription: string;
  marketingBrand: string;
  lot: string;
  location: string;
  memoLot1: string;
  memoLot2: string;
  onHand: string;
  lotLocationReleaseQuantity: number;
  weight: number;
  itemWeight: number;
  quantityAvailable: number;
}

// Class model for items list for lot
export class ItemsList {
  ReleaseItemId: number;
  ItemId: number;
  ItemNumber: string;
  BranchPlant: string;
  ItemUOM: string;
  ReleaseQuantity: number;
}
